import RequestContextService from '../RequestContextService.js';
import autoRefreshAuthToken from './autoRefreshAuthToken.js';

export default function makeUpdateAuthToken(updateAuthToken) {
  const doUpdateAuthToken = (authToken, authTokenExpirationDate, refreshToken) => {
    const requestContext = RequestContextService.get();

    RequestContextService.update(
      {
        ...requestContext,
        authToken,
        authTokenExpirationDate,
        refreshToken
      },
      'keep-original'
    );

    updateAuthToken(authToken);

    autoRefreshAuthToken(authToken, authTokenExpirationDate, refreshToken, doUpdateAuthToken);
  };

  return doUpdateAuthToken;
}
